var __create = Object.create, __defProp = Object.defineProperty, __getOwnPropDesc = Object.getOwnPropertyDescriptor, __getOwnPropNames = Object.getOwnPropertyNames, __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty, __commonJSMin = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports), __export = (e) => {
  let n = {};
  for (var r in e)
    __defProp(n, r, {
      get: e[r],
      enumerable: true
    });
  return n;
}, __copyProps = (e, i, o, s) => {
  if (i && typeof i == "object" || typeof i == "function")
    for (var c = __getOwnPropNames(i), l = 0, u = c.length, d; l < u; l++)
      d = c[l], !__hasOwnProp.call(e, d) && d !== o && __defProp(e, d, {
        get: ((e2) => i[e2]).bind(null, d),
        enumerable: !(s = __getOwnPropDesc(i, d)) || s.enumerable
      });
  return e;
}, __toESM = (n, r, a) => (a = n == null ? {} : __create(__getProtoOf(n)), __copyProps(r || !n || !n.__esModule ? __defProp(a, "default", {
  value: n,
  enumerable: true
}) : a, n)), __toDynamicImportESM = (e) => (t) => __toESM(t.default, e), __require = /* @__PURE__ */ ((e) => typeof require < "u" ? require : typeof Proxy < "u" ? new Proxy(e, { get: (e2, t) => (typeof require < "u" ? require : e2)[t] }) : e)(function(e) {
  if (typeof require < "u")
    return require.apply(this, arguments);
  throw Error('Calling `require` for "' + e + "\" in an environment that doesn't expose the `require` function.");
});
export {
  __toESM as a,
  __toDynamicImportESM as i,
  __export as n,
  __require as r,
  __commonJSMin as t
};
